module.exports = __webpack_public_path__ + "img/insta-11.bb7747c4.jpg";